import {Extension} from "@codemirror/state";
import {EditorView, ViewUpdate} from "@codemirror/view";
import CodeStore from "../../../state/codeStore";
import {CompletionEngine} from "../../../util/cafebabe/src/completion_engine";

/**
 * This extension is used to handle any editor changes.
 *
 * It also applies angle bracket autocompletions.
 */
export const handleEditorChangeExtension = (
	codeStore: CodeStore
): Extension => [
	EditorView.updateListener.of((v: ViewUpdate) => {
		if (v.docChanged && codeStore.focusedFile) {
			// Handle any incoming editor changes here
			// TODO debounce or otherwise optimize this
			codeStore.codeMirrorStore.handleEditorChange(v.state.doc.toString());

			// Only run autocompletion if the change is an opening angle bracket
			if (v.changes.toJSON()[1] && v.changes.toJSON()[1][1] === "<") {
				const completionEngine = new CompletionEngine();

				const project = codeStore.cafebabeProject;
				if (!project) return null;

				const after = v.state.doc.toString();
				const before = v.transactions[0]?.startState.doc.toString();
				if (!before) return;

				project.updateFile(codeStore.focusedFile, before);
				project.analyze();

				const expr1 = project.getFile(codeStore.focusedFile)?.cu;

				project.updateFile(codeStore.focusedFile, after);
				project.analyze();

				const expr2 = project.getFile(codeStore.focusedFile)?.cu;

				if (expr1 && expr2 && v.view) {
					completionEngine.executeFancyActions(
						before,
						after,
						expr1,
						expr2,
						v.state.selection.main.head,
						v.view
					);
				}
			}
		}
	}),
];
export default handleEditorChangeExtension;
